import * as React from 'react';
import intl from 'react-intl-universal';


import './index.less';
const NotFound: React.FC = () => {
    return (
        <div className="pc-notFound-wrapper">
            <div className="pc-notFound-Bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/404.png)` }} />
            <p className="notFound-title">{intl.get(`abnormal_404`)}</p>
            <p className="notFound-sub-title">{intl.get(`abnormal_404_sub`)}</p>
        </div>
    );
};

export default NotFound;
